import React from "react";
import FeedbackBanner from "../../general/correct-feedback/FeedbackBanner";
import DropdownTask from "../../general/dropdown-task/DropdownTask";

const DropdownQuestion = ({
  question,
  dropdownQuestionParts,
  options,
  showAnswerOptions,
  dropdownAmount,
  showCheckButton,
  canCheck,
  onCheck,
  feedbackVisible,
  feedback,
  onCloseFeedback,
  showNextButton,
  onNext,
  showFinishButton,
  onFinish,
  onAllDropdownsSelected,
  questionKey,
}) => {
  return (
    <>
      <DropdownTask
        key={questionKey}
        dropdownQuestionParts={dropdownQuestionParts}
        onAllDropdownsSelected={onAllDropdownsSelected}
        question={question}
        options={options}
        showAnswerOptions={showAnswerOptions}
        dropdownAmount={dropdownAmount}
      />

      {showCheckButton && canCheck && (
        <button className="btn checkAnswer" onClick={onCheck} style={{ display: "inline-block" }}>
          Перевірити
        </button>
      )}

      {feedbackVisible && <FeedbackBanner feedback={feedback} closeFeedback={onCloseFeedback} />}

      {showNextButton && (
        <button className="btn nextAnswer" onClick={onNext} style={{ display: "inline-block" }}>
          Наступне завдання
        </button>
      )}

      {showFinishButton && (
        <button className="btn nextAnswer" onClick={onFinish} style={{ display: "inline-block" }}>
          Завершити
        </button>
      )}
    </>
  );
};

export default DropdownQuestion;
